'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var arrayWithHoles = require('./arrayWithHoles.js');
var iterableToArrayLimit = require('./iterableToArrayLimit.js');
var unsupportedIterableToArray = require('./unsupportedIterableToArray.js');
var nonIterableRest = require('./nonIterableRest.js');

function _slicedToArray(arr, i) {
  return arrayWithHoles.default(arr) || iterableToArrayLimit.default(arr, i) || unsupportedIterableToArray.default(arr, i) || nonIterableRest.default();
}

exports.default = _slicedToArray;
//# sourceMappingURL=slicedToArray.js.map
